import { useCallback } from 'react';
import { useGoogleReCaptcha as _useGoogleReCaptcha } from 'components';
import { ReCaptchaResponse, verifyToken } from '../services/google-recaptcha';
import { newrelic } from 'helpers/reporting/newrelic';
import { useSelector } from 'react-redux';
import { customerIsLoggedInSelector } from 'store/customer/selectors';

export interface GoogleReCaptchaInit {
  pageType?: string
  pageName: string
  action: string
  onVerify?: (token: string) => void
  onSuccess?: (response: ReCaptchaResponse) => void
  runOnMountOnly?: boolean
}

export const useGoogleReCaptcha = (config: GoogleReCaptchaInit): void => {
  const isLoggedIn = useSelector(customerIsLoggedInSelector);

  const handleVerify = useCallback(async (token: string) => {
    if (token) {
      config.onVerify && config.onVerify(token);
      const response = await verifyToken(token);
      /** 
       * NOTE: It is important that when we verify the reCAPTCHA response,
       * we should verify that the action name is the name you expect
       */
      if (response.score < 1.0 || response.action !== config.action) {
        newrelic('addPageAction')('recaptchaVerificationFailure', {
          page: config.pageName,
          action: config.action,
          score: response.score,
          auth: isLoggedIn
        });
        return;
      }
      config.onSuccess && config.onSuccess(response);
    }
  // TODO: Refactor this dependency
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  _useGoogleReCaptcha({ ...config, onVerify: handleVerify });
};
